import Modal from './Modal.android';

export default Modal;
